module.exports = __webpack_public_path__ + "IMAGE.png";